var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./AwardsADGWinnersPopup.jinja');
require('./AwardsADGWinnersPopup.less');

var AwardsADGWinnersList = require('front/components/AwardsADGWinnersList/AwardsADGWinnersList');


module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .AwardsADGWinnersPopup-yearSelector': 'toggleYearDropdown',
        'click .AwardsADGWinnersPopup-film': 'toggleFilm'
    }, BasePopup.prototype.baseEvents),


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AwardsADGWinnersList': {selector: '.AwardsADGWinnersList', viewConstructor: AwardsADGWinnersList}
    },


    apiUrl: function () {
        return Urls['submissions:api:nominees'](this.year, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        this.showLoader = true;

        this.year = this.options.year;

        _.bindAll(this, 'onBodyClick');

        BasePopup.prototype.initialize.call(this, options);
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },


    toggleYearDropdown: function (e) {
        var $selector = this.$('.AwardsADGWinnersPopup-yearSelector');
        var dropdownClass = '.AwardsADGWinnersPopup-yearSelectorDropdown';
        var activeModifier = 'AwardsADGWinnersPopup-yearSelector--active';

        if ($(e.target).closest(dropdownClass).length) return;

        if ($selector.hasClass(activeModifier)) {
            $selector.find(dropdownClass).slideUp(200);
            $selector.removeClass(activeModifier);
            $('body').off('click', this.onBodyClick);
        } else {
            $selector.find(dropdownClass).slideDown(200);
            $selector.addClass(activeModifier);
            $('body').on('click', this.onBodyClick);
        }
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.AwardsADGWinnersPopup-yearSelector').length) return;

        this.toggleYearDropdown(e);
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.js
// module id = 256
// module chunks = 0